<template>
  <div class="home">
    <Layout>
      <Header class="home_header">
        <div class="menu_icon_wrapper">
          <!--<Icon @click.native="collapsedSider" class="menu_icon" :class="rotateIcon" size="24" type="md-menu"></Icon>-->
          <span class="system_name">高奇点管理客服</span>
        </div>
        <div class="userInfo_wrapper">
          <span class="user">欢迎您-高奇点</span>
          <Dropdown class="change_info" placement="bottom-end" trigger="click">
            <a href="javascript:void(0)">更多</a>
            <Icon type="ios-arrow-down"></Icon>
            <DropdownMenu slot="list" class="drop_menu">
              <DropdownItem @click.native="changeInfoStatus = true">修改密码</DropdownItem>
              <DropdownItem @click.native="loginOut">退出</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
      </Header>
      <Layout class="main">
        <Sider
          class="home_nav"
          ref="sider"
          hide-trigger
          collapsible
          :collapsed-width="78"
          v-model="isCollapsed"
        >
          <Menu
            :class="[isCollapsed ? 'hiddenSpan' : 'home_menu']"
            theme="light"
            mode="vertical"
            :active-name="currentValue"
            width="200"
            :open-names="[currentOpenItem]"
            v-on:on-select="selectNav"
          >
            <MenuItem
              v-for="(item,index) in menuList"
              :key="index"
              :name="item.value"
              v-if="!item.subList"
              :to="item.toPage"
            >
              <Icon :type="item.icon"></Icon>
              <span>{{item.title}}</span>
            </MenuItem>
            <Submenu
              :class="[isCollapsed ? 'hidden_sub_span' : 'sub_menu']"
              v-if="item.subList"
              v-for="(item,index) in menuList"
              :key="index"
              :name="item.title"
            >
              <template slot="title">
                <Icon class="sub_icon" :type="item.icon"></Icon>
                <span>{{item.title}}</span>
              </template>
              <MenuItem
                v-for="(sub,num) in item.subList"
                :key="num"
                :name="sub.value"
                :to="sub.toPage"
              >
                <span>{{sub.title}}</span>
              </MenuItem>
            </Submenu>
          </Menu>
        </Sider>
        <Layout class="main_content_wrapper">
          <div class="bread_crumb_wrapper clearfix">
            <Breadcrumb class="bread_crumb">
              <BreadcrumbItem to>{{currentTitle}}</BreadcrumbItem>
            </Breadcrumb>
            <Button
              class="back_btn"
              icon="md-arrow-round-back"
              type="primary"
              ghost
              @click="goBack"
            >返回</Button>
          </div>
          <Content class="table_content">
            <keep-alive
              :include="['OCRCardDetails','Customer','User','Schools','Klasses','Students','Tasks','Notices','Bluetooth','OCRCard']"
            >
              <router-view ></router-view>
            </keep-alive>
          </Content>
        </Layout>
      </Layout>
      <Layout class="home_footer_wrapper">
        <Footer class="home_footer">客服管理</Footer>
      </Layout>
    </Layout>
    <Modal class="change_password" title="修改密码" v-model="changeInfoStatus" :mask-closable="false">
      <div class="modal_wrapper">
        <Input
          class="search_item"
          type="text"
          v-model="userInfo.tel"
          placeholder="请输入手机号"
          clearable
        />
        <div class="code_wrapper search_item">
          <Input
            class="code_ipt"
            type="text"
            v-model="userInfo.captcha"
            placeholder="请输入验证码"
            clearable
          />
          <Button class="get_code_btn" type="info" ghost @click="getCode">{{tipsCode}}</Button>
        </div>
        <div class="ipt-wrapper search_item">
          <Input
            class="code_ipt"
            v-if="!passwordShow"
            :type="passwordIptType"
            ref="passwordIpt"
            v-model="userInfo.password"
            placeholder="请输入新密码"
          />
          <Input
            class="code_ipt"
            v-if="passwordShow"
            type="text"
            ref="passwordIpt"
            v-model="userInfo.password"
            placeholder="请输入新密码"
          />
          <Icon
            class="eye_icon"
            v-if="!passwordShow"
            type="md-eye-off"
            data-context="password"
            @click.native="changeEyeStatus"
          ></Icon>
          <Icon
            class="eye_icon open_eye"
            v-if="passwordShow"
            type="md-eye"
            data-context="password"
            @click.native="changeEyeStatus"
          ></Icon>
        </div>
        <!--<div class="ipt-wrapper">-->
        <!--<Input class="code_ipt" v-if="!confirmPasswordShow" :type="confirmIptType" ref="confirmIpt" v-model="userInfo.confirmPassword" placeholder="请输入再次输入新密码"/>-->
        <!--<Input class="code_ipt" v-if="confirmPasswordShow" type="text" ref="confirmIpt" v-model="userInfo.confirmPassword" placeholder="请输入再次输入新密码"/>-->
        <!--<Icon class="eye_icon" v-if="!confirmPasswordShow" type="md-eye-off" data-context="confirmPassword" @click.native="changeEyeStatus"></Icon>-->
        <!--<Icon class="eye_icon open_eye" v-if="confirmPasswordShow" type="md-eye" data-context="confirmPassword" @click.native="changeEyeStatus"></Icon>-->
        <!--</div>-->
      </div>
      <div class="ctrl-footer" slot="footer">
        <Button class="closed_btn" @click="cancelModal">取消</Button>
        <Button class="add_record_btn" type="primary" @click="confirmChangePassword">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { _getCaptcha, _changePassword } from "../api/api";

export default {
  name: "Home",
  data() {
    return {
      confirmIptType: "password",
      passwordIptType: "password",
      passwordShow: false, //密码可见
      confirmPasswordShow: false, //密码可见
      isCollapsed: false, // 导航隐藏
      currentBreadList: [], //面包屑数据组
      currentTitle: "", // 当前位置
      currentValue: "", // 当前位置
      currentOpenItem: "", // 当前激活的项
      changeInfoStatus: false, // 修改密码模态框显示状态
      menuList: [
        {
          icon: "md-call",
          title: "客服记录",
          value: "customer",
          toPage: "/customer"
        },
        {
          icon: "md-contacts",
          title: "用户管理",
          value: "user",
          toPage: "/user"
        },
        {
          icon: "md-home",
          title: "学校管理",
          value: "schools",
          toPage: "/schools"
        },
        {
          icon: "md-people",
          title: "班级管理",
          value: "klasses",
          toPage: "/klasses"
        },
        {
          icon: "md-man",
          title: "学生管理",
          value: "students",
          toPage: "/students"
        },
        {
          icon: "md-color-palette",
          title: "作业管理",
          value: "tasks",
          toPage: "/tasks"
        },
        {
          icon: "md-volume-up",
          title: "通知管理",
          value: "notices",
          toPage: "/notices"
        },
        {
          icon: "md-star",
          title: "教辅管理",
          //            value: 'teaching',
          //            toPage: "/teaching",
          subList: [
            {
              title: "教辅列表",
              value: "teaching",
              toPage: "/teaching"
            },
            {
              title: "教辅答题本",
              value: "answer",
              toPage: "/answer"
            },
            {
              title: "教辅切题",
              value: "TeachingBorderList",
              toPage: "/TeachingBorderList"
            }
          ]
        },
        {
          icon: "md-settings",
          title: "OCR识别",
          //            value: 'teaching',
          //            toPage: "/teaching",
          subList: [
            {
              title: "参数配置",
              value: "OCRConfig",
              toPage: "/OCRConfig"
            },
            {
              title: "识别方案",
              value: "OCRSetting",
              toPage: "/OCRSetting"
            },
            {
              title: "识别答题卡",
              value: "OCRCard",
              toPage: "/OCRCard"
            }
          ]
        },
        {
          icon: "md-pricetag",
          title: "标签管理",
          value: "tags",
          toPage: "/tags"
        },
        {
          icon: "ios-book",
          title: "纸屏数据统计",
          value: "bookstatistics",
          toPage: "/bookstatistics"
        },
        {
          icon: "md-bluetooth",
          title: "蓝牙数据",
          value: "bluetooth",
          toPage: "/bluetooth"
        },
        {
          icon: "md-eye",
          title: "视频审核",
          value: "videoFilter",
          toPage: "/videoFilter"
        }
      ],
      userInfo: {
        tel: "",
        captcha: "",
        password: "",
        confirmPassword: ""
      },
      tipsCode: "获取短信验证码",
      CodeClickStatus: true // 获取验证码可点击状态
    };
  },
  computed: {
    rotateIcon() {
      return ["menu-icon", this.isCollapsed ? "rotate-icon" : ""];
    }
    //      currentAdd () {
    //        let currentPath = this.$route.path;
    //        return
    //      }
  },
  watch: {
    $route: "getPath"
  },
  methods: {
    selectNav(e) {
      const self = this;
      //        self.currentAdd = e;
      //        console.log("path", self.$route.path)
    },
    //      控制密码框眼睛
    changeEyeStatus(e) {
      let context = e.target.dataset.context;
      if (context === "password") {
        this.passwordShow = !this.passwordShow;
        this.passwordIptType = this.passwordShow ? "text" : "password";
      } else if (context === "confirmPassword") {
        this.confirmPasswordShow = !this.confirmPasswordShow;
        this.confirmIptType = this.confirmPasswordShow ? "text" : "password";
      }
    },
    //      修改密码
    confirmChangePassword() {
      const self = this;
      let dataInfo = {
        password: self.userInfo.password,
        captcha: self.userInfo.captcha
      };
      _changePassword(dataInfo).then(res => {
        if (res.code === 0) {
          self.changeInfoStatus = false;
          clearInterval(self.timer);
        }
      });
    },
    //      退出登录
    loginOut() {
      let confirmStatus = confirm("确认退出登录？");
      if (confirmStatus) {
        this.$router.replace("/");
      } else {
      }
    },
    //      关闭弹出框
    cancelModal() {
      this.changeInfoStatus = false;
      clearInterval(this.timer);
    },
    //     验证码控制
    getCode() {
      let self = this;
      let telStatus = /^1[3-9]\d{9}$/gi.test(self.userInfo.tel);
      if (!telStatus) {
        self.$Message.info("请输入正确的手机号");
        return;
      }
      if (self.CodeClickStatus) {
        self.getCaptcha();
        self.tipsCode = "60秒";
        self.CodeClickStatus = false;
        let showTime = parseInt(self.tipsCode);
        self.timer = setInterval(function() {
          if (showTime > 1) {
            showTime--;
            self.tipsCode = showTime + "秒";
          } else {
            self.tipsCode = "获取短信验证码";
            self.CodeClickStatus = true;
            clearInterval(self.timer);
          }
        }, 1000);
      }
    },
    //      获取手机验证码
    getCaptcha() {
      const self = this;
      let dataInfo = {
        data: self.userInfo.tel
      };
      _getCaptcha(dataInfo).then(res => {
        if (res.code === 0) {
        } else {
        }
      });
    },

    //      返回
    goBack() {
      this.$router.go(-1);
    },
    getPath() {
      let currentBreadList = [];
      let currentPath = this.$route.path;
      let status = false;
      for (const item of this.menuList) {
        this.currentOpenItem = item.title;
        if (item.subList) {
          item.subList.forEach(sub => {
            if (currentPath.indexOf(sub.value) > -1) {
              this.currentValue = sub.value;
              this.currentTitle = sub.title;
              status = true;
            }
          });
        } else {
          if (currentPath.indexOf(item.value) > -1) {
            this.currentValue = item.value;
            this.currentTitle = item.title;
            status = true;
          }
        }
      }
      if (!status) {
        this.currentValue = this.menuList[0].value;
        this.currentTitle = this.menuList[0].title;
        this.currentOpenItem = this.menuList[0].title;
      }
    },
    collapsedSider() {
      this.$refs.sider.toggleCollapse();
    }
  },
  mounted() {
    this.getPath();
  }
};
</script>
<style scoped>
.home {
}

.home_header {
  flex: 0 0 64px;
  display: flex;
  height: 64px;
  flex-direction: row;
  padding: 0;
}

.main {
  flex: 1;
  min-height: 450px;
}

.menu_icon_wrapper {
  flex: 0 0 300px;
  width: 300px;
}

.userInfo_wrapper {
  flex: 1;
  padding-right: 30px;
  box-sizing: border-box;
  color: #fff;
  text-align: right;
}

.userInfo_wrapper > .user {
  margin-right: 30px;
  font-size: 18px;
}

.drop_menu {
  text-align: center;
}

.menu_icon {
  margin-left: 20px;
  color: #fff;
}

.system_name {
  display: inline-block;
  margin-left: 25px;
  line-height: 64px;
  font-size: 24px;
  color: #fff;
}

.main_content_wrapper {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  /*position:relative;*/
  /*overflow: hidden;*/
}

.bread_crumb_wrapper {
  flex: 0 0 53px;
  display: flex;
  height: 53px;
  padding: 8px 15px;
  border-bottom: 1px solid #2d8cf0;
  box-shadow: 0 0 2px #2d8cf0;
  line-height: 36px;
  color: #999;
}

.bread_crumb {
  flex: 1;
  font-size: 18px;
}

.back_btn {
  flex: 0 0 60px;
  width: 60px;
  padding: 0 8px;
}

.table_content {
  flex: 1;
  padding: 10px 15px 20px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  /*position: absolute;*/
  /*width:100%;*/
  /*height:calc(100% - 53px);*/
  /*top:53px;*/
  /*left:0;*/
  /*overflow-x: hidden;*/
  /*overflow-y: scroll;*/
}
/*.table_content::-webkit-scrollbar{*/
/*  width:4px;*/
/*}*/
/*.table_content::-webkit-scrollbar-thumb{*/
/*  -webkit-border-radius: 4px;*/
/*  -moz-border-radius: 4px;*/
/*  border-radius: 4px;*/
/*  -webkit-box-shadow: inset 0px 0px 5px #ccc;*/
/*  -moz-box-shadow: inset 0px 0px 5px #ccc;*/
/*  box-shadow: inset 0px 0px 5px #ccc;*/
/*  background:#aaa;*/
/*}*/
/*.table_content::-webkit-scrollbar-track{*/
/*  width:4px;*/
/*  background:#fff;*/
/*}*/
.home_nav {
  /*position:relative;*/
  /*overflow: hidden;*/
  background: #fff;
}

.home_nav .ivu-layout-sider-children {
  border-right: 2px solid #dcdee2;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
/*.home_menu{*/
/*  position: absolute;*/
/*  top:0;*/
/*  left:0;*/
/*  overflow-x: hidden;*/
/*  overflow-y: scroll;*/
/*  width:200px;*/
/*  height:100%;*/
/*  -webkit-box-sizing: border-box;*/
/*  -moz-box-sizing: border-box;*/
/*  box-sizing: border-box;*/
/*}*/
/*.home_menu::-webkit-scrollbar{*/
/*  width:4px;*/
/*}*/
/*.home_menu::-webkit-scrollbar-thumb{*/
/*  -webkit-border-radius: 4px;*/
/*  -moz-border-radius: 4px;*/
/*  border-radius: 4px;*/
/*  -webkit-box-shadow: inset 0px 0px 5px #ccc;*/
/*  -moz-box-shadow: inset 0px 0px 5px #ccc;*/
/*  box-shadow: inset 0px 0px 5px #ccc;*/
/*  background:#aaa;*/
/*}*/
/*.home_menu::-webkit-scrollbar-track{*/
/*  width:4px;*/
/*  background:#eee;*/
/*}*/
.home_menu:after {
  background: none;
}

.home_menu > a {
  font-size: 16px;
}

.home_menu > a:hover {
  background: #f0faff;
}

.hiddenSpan > a > span,
.hidden_sub_span span {
  display: none;
  font-size: 20px;
}

.hiddenSpan > a {
  font-size: 20px;
}

.hidden_sub_span {
  font-size: 20px;
}

.hidden_sub_span:after {
  /*display: none;*/
}

.home_footer_wrapper {
  flex: 0 0 60px;
  height: 60px;
  text-align: center;
}

.home_footer {
  height: 60px;
  line-height: 60px;
  padding: 0;
  background: #515a6e;
  color: #fff;
}

.layout {
  border: 1px solid #d7dde4;
  background: #f5f7f9;
  position: relative;
  overflow: hidden;
  border-radius: 4px;
}

.layout-header-bar {
  background: #fff;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}

.layout-logo-left {
  width: 90%;
  height: 30px;
  background: #5b6270;
  border-radius: 3px;
  margin: 15px auto;
}

.menu-icon {
  transition: all 0.3s;
}

.rotate-icon {
  transform: rotate(-90deg);
}

.menu-item span {
  display: inline-block;
  overflow: hidden;
  width: 69px;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
  transition: width 0.4s linear;
}

.menu-item i {
  transform: translateX(0px);
  transition: font-size 0.4s ease, transform 0.8s linear;
  vertical-align: middle;
  font-size: 16px;
}

.collapsed-menu span {
  width: 0px;
  transition: width 0.4s linear;
}

.collapsed-menu i {
  transform: translateX(5px);
  transition: font-size 0.4s ease 0.8s;
  vertical-align: middle;
  font-size: 22px;
}

.code_wrapper {
  display: flex;
}

.code_ipt {
  flex: 1;
}

.get_code_btn {
  flex: 0 0 120px;
  width: 120px;
  margin-left: 15px;
}

.ipt-wrapper {
  position: relative;
}

.eye_icon {
  position: absolute;
  top: 0;
  right: 0;
  padding: 6px 15px;
  font-size: 20px;
  cursor: pointer;
}

.open_eye {
  color: #2d8cf0;
}

.sub_menu {
  font-size: 16px;
}

.sub_menu .sub_icon {
  vertical-align: text-top;
}

/*.fade-enter-active, .fade-leave-active{*/
/*transition:opacity 0.3s linear 0.3s;*/
/*}*/
/*.fade-enter, .fade-leave-to{*/
/*opacity:0;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/components/Home.vue